import React, { Component } from 'react';
import { connect } from 'react-redux';

import { checkValidity } from '../../../shared/utility';
import imgLogo from 'images/logo-2.png';
import * as actions from 'actions/index';
import {
  isComposerShown,
  openSupportComposer,
  subscribeComposerShown,
} from '../../../support/supportEntry';

const initialState = {
  formIsValid: false,
  contactForm: {
    senderNameFrom: {
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
    },
    company: {
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
    },
    emailFrom: {
      value: '',
      validation: {
        required: true,
        email: true,
      },
      valid: false,
      touched: false,
    },
    body: {
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
    },
  },
};

class footer extends Component {
  constructor(props) {
    super(props);
    // supportChat: the support composer is on screen, so "Chat with us" takes the contact form's place.
    this.state = { ...initialState, supportChat: isComposerShown() };
  }

  componentDidMount() {
    this.stopWatchingSupport = subscribeComposerShown(supportChat =>
      this.setState({ supportChat })
    );
    if (this.state.supportChat !== isComposerShown()) {
      this.setState({ supportChat: isComposerShown() });
    }
  }

  componentWillUnmount() {
    if (this.stopWatchingSupport) this.stopWatchingSupport();
  }

  handleInput = event => {
    let updatecontactForm = {
      ...this.state.contactForm,
    };

    let updateFormElement = {
      ...updatecontactForm[event.target.name],
    };

    updateFormElement.value = event.target.value;

    updateFormElement.valid = checkValidity(
      updateFormElement.value,
      updateFormElement.validation
    );
    updateFormElement.touched = true;

    updatecontactForm[event.target.name] = updateFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatecontactForm) {
      formIsValid = updatecontactForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ contactForm: updatecontactForm, formIsValid: formIsValid });
  };

  handleSendEmail = event => {
    event.preventDefault();
    const payload = {};
    for (let formElementIndentifier in this.state.contactForm) {
      payload[formElementIndentifier] = this.state.contactForm[
        formElementIndentifier
      ].value;
    }
    this.props.onSendEmailContact(payload);
  };

  componentDidUpdate(prevProps) {
    if (this.props.isSentEmailContact !== prevProps.isSentEmailContact) {
      this.resetContactForm();
    }
  }

  resetContactForm = () => {
    this.setState(initialState);
  };

  // Where the support composer is on screen: it takes questions and new sales leads (name, email and
  // company before the first message), so the footer points to it instead of the contact form.
  renderSupportChat() {
    return (
      <div className="form-contact form-contact--chat">
        <span>Contact</span>
        <p>
          Questions about Lunch.Team or signing up your company? Chat with us.
        </p>
        <button
          type="button"
          className="bt form-contact__chat"
          onClick={openSupportComposer}
        >
          Chat with us
        </button>
      </div>
    );
  }

  render() {
    let disable = {
      cursor: 'pointer',
    };

    if (!this.state.formIsValid) {
      disable = {
        background: 'var(--lt-color-muted)',
        color: 'var(--lt-color-muted-foreground)',
        border: '1px solid var(--lt-color-border)',
        cursor: 'not-allowed',
      };
    }

    return (
      <footer>
        <div className="wrap">
          <div ref={this.props.footRef} className="wrapper">
            <img alt="logo" className="logo-2" src={imgLogo} />
          </div>
          <nav className="menu">
            <a onClick={this.props.handleHowItWorks} className="get-more-info">
              How It Works
            </a>
            <a onClick={this.props.handleWhatWeDo}>What We Do</a>
            <a onClick={this.props.handleOurClients}>Some of Our Clients</a>
            <a onClick={this.props.handleWhyUseUs}>Benefits</a>
            <a
              onClick={() => window.open('https://forms.gle/tP6qdYZrb8K8fh7i7')}
            >
              Become a Driver today!
            </a>
          </nav>

          {this.state.supportChat ? (
            this.renderSupportChat()
          ) : (
            <div className="form-contact">
              <span>Contact</span>
              <form>
                <div className="col-1 w-50 left">
                  <input
                    placeholder="Enter Name"
                    className={
                      !this.state.contactForm['senderNameFrom'].valid &&
                      this.state.contactForm['senderNameFrom'].touched
                        ? 'Invalid'
                        : null
                    }
                    name="senderNameFrom"
                    type="text"
                    value={this.state.contactForm.senderNameFrom.value}
                    onChange={this.handleInput}
                  />
                  <input
                    placeholder="Enter Email"
                    className={
                      !this.state.contactForm['emailFrom'].valid &&
                      this.state.contactForm['emailFrom'].touched
                        ? 'Invalid'
                        : null
                    }
                    name="emailFrom"
                    type="text"
                    value={this.state.contactForm.emailFrom.value}
                    onChange={this.handleInput}
                  />
                  <input
                    placeholder="Enter Company"
                    className={
                      !this.state.contactForm['company'].valid &&
                      this.state.contactForm['company'].touched
                        ? 'Invalid'
                        : null
                    }
                    name="company"
                    type="text"
                    value={this.state.contactForm.company.value}
                    onChange={this.handleInput}
                  />
                </div>
                <div className="col-2 w-50 left">
                  <textarea
                    placeholder="Enter Message"
                    className={
                      !this.state.contactForm['body'].valid &&
                      this.state.contactForm['body'].touched
                        ? 'Invalid'
                        : null
                    }
                    name="body"
                    value={this.state.contactForm.body.value}
                    onChange={this.handleInput}
                  />
                  <input
                    className="bt right"
                    disabled={!this.state.formIsValid}
                    type="submit"
                    style={disable}
                    onClick={this.handleSendEmail}
                    value="Send"
                  />
                </div>
              </form>
              <div
                style={{
                  display: this.props.isSentEmailContact ? 'block' : 'none',
                }}
                className="message-sent"
              >
                Message sent!
              </div>
            </div>
          )}
          <div className="lets">
            Lets Do Lunch
            <ul className="social">
              <li className="left">
                <a
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/lunch.team"
                  target="_blank"
                >
                  <i className="fa fa-instagram" />
                </a>
              </li>
            </ul>
            <a
              href="/Privacy"
              style={{ padding: '10px 0', marginRight: '30px' }}
            >
              Privacy
            </a>
            <a href="/Terms" style={{ padding: '10px 0' }}>
              Terms
            </a>
          </div>
          <small className="copyright">
            Lunch.Team is a registered business name of Downthesofa Ireland
            Limited. Bookd is developed and operated by Downthesofa Ireland
            Limited.
          </small>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSentEmailContact: state.landingReducer.isSentEmailContact,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSendEmailContact: payload => dispatch(actions.sendEmailContact(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(footer);



// WEBPACK FOOTER //
// ./src/containers/Landing/Footer/index.js